import { Icon } from '@eventbrite/legacy-eds.icon';
import { AlertChunky as AlertChunkySvg } from '@eventbrite/legacy-eds.iconography';
import { ErrorBoundary } from '@eventbrite/legacy-infra.error-boundary';
import { useIntl } from 'react-intl';
import React from 'react';
import styles from './ErrorBoundary.module.scss';

const ViewFallBack = () => {
    const intl = useIntl();
    const errorTitle = intl.formatMessage({
        id: 'Uh oh.',
        defaultMessage: 'Uh oh.',
    });
    const errorMessage = intl.formatMessage({
        id: 'Looks like we have a problem.',
        defaultMessage: 'Looks like we have a problem.',
    });
    const errorFooter = intl.formatMessage({
        id: 'Our team has been notified and we are investigating.',
        defaultMessage: 'Our team has been notified and we are investigating.',
    });
    return (
        <div
            className={styles.errorContainer}
            style={{ flexDirection: 'column' }}
        >
            <Icon size="medium" type={<AlertChunkySvg />} />
            <div className={styles.errorTitle}>{errorTitle}</div>
            <div className={styles.errorMessage}>{errorMessage}</div>
            <div className={styles.errorFooter}>{errorFooter}</div>
        </div>
    );
};

export const ViewErrorBoundary = (props: { children: React.ReactNode }) => {
    return (
        <ErrorBoundary fallback={()=><ViewFallBack />}>
            {props.children}
        </ErrorBoundary>
    );
};

export const ModalErrorBoundary = (props: { children: React.ReactNode }) => {
    return <ErrorBoundary fallback={()=><div />}>{props.children}</ErrorBoundary>;
};
